import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import HttpRunner from '../query';
import LocationFinderQuery from '../locationFinderQuery';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';
import miscUtils from '../../../utils/miscUtils';

class DocV1InformationExtractionPrompts extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_INFORMATION_EXTRACTION_PROMPTS)
        })
    }

    render() {
        return (
            <div className="bucket" id="top">
                <h3 className="heading-1">Information Extraction Prompts</h3>
                <code className="api-definition">
                    <span className="get-badge">GET</span>&nbsp;{urlHandler.API_ENDPOINT_V1_INFORMATION_EXTRACTION_PROMPTS}
                </code>
                <div className="description">
                    The Information Extraction Prompts API endpoint returns a list of available prompts which can be used to override the default when using the informationExtraction feature on an <Link to="/documentation/doc_v2enrich">enrich </Link>request.<br/>
                </div>

                <h4 className="heading-2" id="lfv1_response">Response</h4>
                <div className="description enrich">
                    Location finder returns list of available prompts and descriptions.
                </div>

                <h4 className="heading-3" id="lfv1_response_object">Response object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">promptTemplates</td>
                        <td className="meaning">List of prompt objects with a description containing a string description of the prompt and a name key to with the string to be passed when enriching a document with informationExtration set to True.
                        </td>
                        <td className="type">JSON Object</td>
                        <td className="type"></td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2">Example Request</h4>
                <div className="example-content host">
                    <pre>
                        GET {urlHandler.API_ENDPOINT_V1_INFORMATION_EXTRACTION_PROMPTS}<br/>
                        Accept: application/json<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                        <br/>
                    </pre>
                    <pre>http://example.com/api/v1/information-extraction-prompts</pre>
                </div>
                <h4 className="heading-2">Example Response</h4>
                <pre>
                    {JSON.stringify(examples.EXAMPLE_RESPONSE_V1_INFORMATION_EXTRACTION_PROMPTS, null, 3)}
                </pre>                
            </div>
        );
    }
}

export default DocV1InformationExtractionPrompts;